export const HOME = '/home'
export const BIN = '/bin'
export const MANAGE_LABELS = '/labels/manage'
